// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"98641694","126":"7cd3a6e7","190":"7dffa5c5","240":"8028fbcf","245":"904b1629","329":"d5e0702b","489":"c4396b67","566":"2f0f4f5e","621":"0ad53094","721":"899d9452","762":"75dac24a","899":"2927b5bf"}[chunkId] + ".chunk.js";
};